module.exports = __webpack_public_path__ + "img/icon-success2.png";